import { parseLangCode } from './localize';

enum RtlLangCodes {
  Arabic = 'ar',
  Aramaic = 'arc',
  Avestan = 'ae',
  Bakthiari = 'bqi',
  Dhivehi = 'dv',
  Gilaki = 'glk',
  Hebrew = 'he',
  Kurdish = 'ku',
  Mazanderani = 'mzn',
  Nko = 'nqo',
  Pashto = 'ps',
  Persian = 'fa',
  Sindhi = 'sd',
  Sorani = 'ckb',
  SouthernBalochi = 'bcc',
  Urdu = 'ur',
  Uyghur = 'ug',
  WesternPunjabi = 'pnb',
  Yiddish = 'yi'
}

const rtlLangMap: { [key in RtlLangCodes]: boolean } = {
  [RtlLangCodes.Avestan]: true,
  [RtlLangCodes.Arabic]: true,
  [RtlLangCodes.Aramaic]: true,
  [RtlLangCodes.SouthernBalochi]: true,
  [RtlLangCodes.Bakthiari]: true,
  [RtlLangCodes.Sorani]: true,
  [RtlLangCodes.Dhivehi]: true,
  [RtlLangCodes.Persian]: true,
  [RtlLangCodes.Gilaki]: true,
  [RtlLangCodes.Hebrew]: true,
  [RtlLangCodes.Kurdish]: true,
  [RtlLangCodes.Mazanderani]: true,
  [RtlLangCodes.Nko]: true,
  [RtlLangCodes.WesternPunjabi]: true,
  [RtlLangCodes.Pashto]: true,
  [RtlLangCodes.Sindhi]: true,
  [RtlLangCodes.Uyghur]: true,
  [RtlLangCodes.Urdu]: true,
  [RtlLangCodes.Yiddish]: true
};

export const isRtlLangCode = (langCode: string): boolean => {
  const parsedLocale = parseLangCode(langCode);

  if (!parsedLocale) {
    return false;
  }

  const isLanguageRtl: boolean | undefined =
    rtlLangMap[parsedLocale.language as RtlLangCodes];

  return isLanguageRtl ? true : false;
};
